<div class="core-targets-list" *ngIf="coreTargets.length > 0">
  <ion-list>
    <ion-item *ngFor="let ctg of coreTargets" class="entry-item" lines="none">
      <ion-thumbnail
        *ngIf="thumbUrls[ctg.nfcID]"
        slot="start"
        class="core-target-thumb"
        (click)="openImage(ctg)">
        <img [src]="thumbUrls[ctg.nfcID]" [alt]="ctg.name" />
      </ion-thumbnail>
      <ion-label>
        <h2>{{ ctg.name }}</h2>
      </ion-label>
      <ion-buttons slot="end">
        <ion-button fill="clear" color="danger" (click)="removeTarget(ctg)">
          <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-item>
  </ion-list>
</div>

<div class="no-entries" *ngIf="coreTargets.length === 0">
  <p>{{ "DASHPAGES.MissingComponentText" | translate }} {{ "DASHPAGES.Coretargets" | translate }}.</p>
</div>
